import { get, post } from '../utils/request';

export const getTextElement = function (parameter) {
  return get('/api/v1/textelement', {}, { params: parameter });
};

export const getImprintSizing = function (imprintSizingRequest) {
  return post('/api/v1/imprintSizing', imprintSizingRequest);
};
